import { Component } from '@angular/core';
import {
    FormControl,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@app/shared/material/material.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-template-name-dialog',
    templateUrl: './template-name-dialog.component.html',
    styleUrl: './template-name-dialog.component.scss',
    imports: [
        CommonModule,
        MaterialModule,
        TranslateModule,
        ReactiveFormsModule,
    ],
})
export class TemplateNameDialogComponent {
    templateNameDialogFormGroup = new FormGroup({
        templateName: new FormControl<string>('', Validators.required),
    });

    constructor(public dialogRef: MatDialogRef<TemplateNameDialogComponent>) {}

    saveTemplateName() {
        if (this.templateNameDialogFormGroup.valid) {
            this.dialogRef.close(
                this.templateNameDialogFormGroup.controls.templateName.value
            );
        }
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
